import { ExternalSubItem } from "../../../../domain/document/items";
import { IExternalSubItemBean } from "../beans/items";

export class ExternalCommonTranslator {
  static toSubItems(beans: IExternalSubItemBean[]): ExternalSubItem[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toSubItem(bean));
  }

  static toSubItem(bean: IExternalSubItemBean): ExternalSubItem {
    const item = new ExternalSubItem();
    item.name = bean.name;
    item.key = bean.key;
    item.isVariable = (bean.itemType === 1);
    item.value = bean.value;
    return item;
  }
}
